export const CTAs = {
  ctaNoLockInBoldText: 'No lock in: ',
  ctaNoLockInText: 'skip or cancel for free anytime',
  ctaVeggieBoldText: '185+ veggie (incl. vegan) ',
  ctaVeggieText: 'recipes a month',
  ctaNextDayDeliveryBoldText: 'FREE next day delivery',
  ctaNextDayDeliveryText: ' on your first box',
}

export const HeroSlides = {
  titlePart1: "The UK's",
  titlePart2: 'best recipe',
  titlePart3: 'box for',
  titlePart4: 'choice',
  subTitlePart1Mobile: 'Discover our biggest menu ever',
  subTitlePart2Mobile: 'with 175+ recipes every week',
  subTitlePart1Desktop: 'Discover our biggest menu ever',
  subTitlePart2Desktop: 'with 175+ recipes every week',
}

export const VeganSlides = {
  titlePart: 'Veggie & vegan',
  subTitlePart1: 'Over 250 recipes',
  subTitlePart2: 'every month including:',
}
